//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import exportacao from '../../../../../../../common/resources/downloads';
import basePath from '../../../../../../../common/functions/api-resource';

export default {
  name: 'ListarEvidencia',
  props: {
    pendencia: null,
  },
  data() {
    return {
      execucaoResources: this.$api.execucao(this.$resource),
      evidencias: [],
    };
  },
  watch: {
    pendencia() {
      this.listarEvidencias();
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessDownload() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el === 'APU_DOWNLOAD').length;
    },
  },
  methods: {
    listarEvidencias() {
      if (!this.canAccessDownload) {
        return;
      }
      const id = this.pendencia.idMeta;
      this.execucaoResources.listar({ id }, { id })
        .then((response) => {
          this.evidencias = response.data;
        })
        .catch((err) => {
          this.$toast.create(err.data.error, 'snack', 3E3);
        });
    },
    visualizarArquivo(row) {
      const getBasePath = basePath('execucao', 'execucao');
      const resource = exportacao(this.$http);

      resource.downloadGetAba(getBasePath, {
        param: '',
        url: `${row.id}/pdf`,
      })
        .then(() => {
        })
        .catch(() => {
          this.$toast.create('Erro ao exportar. Tente novamente.', 'snack', 3E3);
        });
    },
  },
  mounted() {
    this.listarEvidencias();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/ListarEvidencia.vue?vue&type=script&lang=js&